<script setup lang="ts">
defineProps({
  score: Number,
  color: {
    type: String,
    default: "blue"
  }
});
</script>

<template>
  <div class="d-flex">
    <v-progress-linear
      height="13px"
      :color="color"
      :model-value="score < 0 ? score * -1 * 10 : score === 0 ? 2 : 0"
      class="rounded-bs rounded-ts"
      reverse
    />
    <div
      class="learning-styles-summary-metrics-metric-gauge-line float-left"
    />
    <v-progress-linear
      :color="color"
      class="rounded-te rounded-be"
      height="13px"
      :model-value="score > 0 ? score * 10 : score === 0 ? 2 : 0"
    />
  </div>
</template>

<style scoped>
.learning-styles-summary-metrics-metric-gauge-line {
  width: 2px;
  background: #c6c6c6;
}
</style>
